import {AxiosError} from 'axios';
import {DELETE_USER_GROUP_URL} from 'web-library/constants/apiUrls';
import {
  UserGroupApproverRequest
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useDeleteUserGroup = ({onSuccess, onError, uuid}: Input) => {
  const deleteUserGroup = async (reqBody: UserGroupApproverRequest) => {
    await axiosClient.delete<void>(DELETE_USER_GROUP_URL(uuid), {
      data: reqBody,
    });
  };

  return useCustomMutation(deleteUserGroup, {
    onSuccess,
    onError,
  });
};
